import React, { Component, Fragment } from 'react';
import { CardElement, ElementsConsumer } from '@stripe/react-stripe-js';
import _ from 'lodash';

import {
  Button,
  Collapse,
  Form,
  Input,
  Spin,
  Switch,
  Row,
  Col,
  Tooltip,
} from 'antd';

import { ErrorsList } from '../../ErrorsList';
import { ButtonBar } from '../../elements';
import { asyncValidator, connectForm } from '../../form';

import './stripe.css';

const { Panel } = Collapse;

@connectForm(() => ({}))
class Inner extends Component {
  constructor() {
    super();
    this.state = {
      loading: false,
      saveInProgress: false,
      errors: {},
    };
  }

  componentDidMount() {
    this.setState(state => ({
      ...state,
      coupon: this.props.coupon ? this.props.coupon : '',
    }));
  }


  submitWithCard = async name => {
    const { stripe, elements } = this.props;
    if (!stripe || !elements) {
      return;
    }
    const cardElement = elements.getElement(CardElement);
    if (!name) {
      this.setState({ errors: { name: ['Name is required'] } });
      return;
    }

    this.setState({
      saveInProgress: true,
    });

    const { token, error } = await this.props.stripe.createToken(cardElement);

    if (error) {
      this.setState({
        saveInProgress: false,
        errors: error ? { card: [error.message] } : {},
        globalErrors: [],
      });
      return;
    }

    const { success, data } = await this.props.postAction({
      card: {
        token: token.id,
      },
      coupon: this.state.coupon,
    });

    if (success && typeof this.props.onSuccess === 'function') {
      this.props.onSuccess();
      return;
    }

    this.setState({
      errors: data._errors || {},
      saveInProgress: false,
      globalErrors: (data._errors || {})._request || [],
    });
  }

  submitWithInvoice = async type => {
    this.setState({
      saveInProgress: true,
    });

    const { data, success } = await this.props.postAction({
      [type]: {
        invoiceRequested: true,
      },
      coupon: this.state.coupon,
    });

    if (success && typeof this.props.onSuccess === 'function') {
      this.props.onSuccess();
      return;
    }

    this.setState({
      errors: data._errors || {},
      saveInProgress: false,
      globalErrors: (data._errors || {})._request || [],
    });
  }

  onSubmit = evt => {
    evt.preventDefault();
    if (this.state.loading) return;
    const stripeInvoice = this.props.form.getFieldValue('paymentMethod.stripeInvoice.invoiceRequested');
    const xeroInvoice = this.props.form.getFieldValue('paymentMethod.xeroInvoice.invoiceRequested');
    if (stripeInvoice) {
      this.submitWithInvoice('stripeInvoice');
    } else if (xeroInvoice) {
      this.submitWithInvoice('xeroInvoice');
    } else {
      this.submitWithCard(evt.target.name.value);
    }
  }

  validateCardName = asyncValidator(
    (rule, value) => {
      const cardInfo = this.props.form.getFieldValue('cardInfo');
      if (cardInfo && !_.get(cardInfo, 'empty')) {
        if (!value) {
          return ['Name is required'];
        }
      }
      return [];
    },
  )

  validate = field => {
    const e = this.state.errors[field];
    if (!e) {
      return {};
    }

    return {
      validateStatus: 'error',
      help: e,
    };
  }

  onStripeInvoice = checked => {
    if (checked) {
      this.props.form.resetFields(['cardName']);
      const cardElement = this.props.elements.getElement(CardElement);
      if (cardElement) {
        cardElement.clear();
      }
    }
  }

  onXeroInvoice = checked => {
    if (checked) {
      this.props.form.resetFields(['cardName']);
      const cardElement = this.props.elements.getElement(CardElement);
      if (cardElement) {
        cardElement.clear();
      }
    }
  }

  onChangeCoupon = evt => {
    const couponText = evt.target.value;
    this.setState(state => ({
      ...state,
      coupon: couponText,
    }));
  }

  render() {
    const {
      loading, saveInProgress, cancelable = true,
    } = this.state;

    const { form, currentPaymentOption, editMode = true } = this.props;
    const { getConnectedFieldDecorator } = form;
    const stripeInvoice = form.getFieldValue('paymentMethod.stripeInvoice.invoiceRequested');
    const xeroInvoice = form.getFieldValue('paymentMethod.xeroInvoice.invoiceRequested');
    const selectedBillingPeriod = form.getFieldValue('plan.billingPeriod');
    const email = form.getFieldValue('info.email') || this.props.email;
    const disableXeroInvoice = selectedBillingPeriod && selectedBillingPeriod === 'monthly';

    const invoiceInstruction = (<p className='invoice-instruction'>
      {stripeInvoice ? 'Stripe' : 'We'} will send invoices to your main organisation <Tooltip id={'email-tooltip'} title={email}><span className='invoice-email'>email address</span></Tooltip>.</p>);

    const disableXeroInvoiceInstruction = (<p className='invoice-instruction'>Invoice option is allowed only for annual subscription.</p>);
    const switchToXeroDisable = currentPaymentOption === 'card' || currentPaymentOption === 'stripeInvoice';
    const switchToXeroDisableInstruction = 'Switching from or to Xero invoices is not permitted at this time. Please contact support@weareoho.com for assistance.';

    const coupon = this.props.showCoupon ? (
      <Form.Item label="Coupon">
        { getConnectedFieldDecorator('paymentMethod.coupon', {
        })(
          <Input
            name="coupon"
          />,
        )}
      </Form.Item>
    ) : null;

    if (editMode && currentPaymentOption === 'xeroInvoice') {
      return (
        <div>
          <p>{switchToXeroDisableInstruction}</p>
        </div>
      );
    }

    const Wrapper = editMode ? Form : Fragment;

    return (
      <Wrapper {...(editMode && { onSubmit: this.onSubmit })}>
        <ErrorsList errors={this.state.globalErrors} />
        <Spin spinning={loading}>
          <Collapse accordion>
            <Panel header="Credit Card">
              <Row gutter={16}>
                <Col sm={24} md={12}>
                  <Form.Item label="Name on card"
                    style={{ marginBottom: '0.3rem' }}
                  >
                    { getConnectedFieldDecorator('cardName', {
                      rules: [
                        { validator: this.validateCardName },
                      ],
                    })(
                      <Input name="name" autoComplete="cc-name" disabled={stripeInvoice || xeroInvoice} />,
                    )}
                  </Form.Item>
                </Col>
                <Col sm={24} md={12}>
                  <Form.Item label="Card Number"
                    style={{ marginBottom: '0.3rem' }}
                    id="cardElement"
                    {...this.validate('card')}
                  >
                    { getConnectedFieldDecorator('cardInfo', {
                    })(
                      <CardElement options={{ disabled: stripeInvoice || xeroInvoice }} />,
                    )}
                  </Form.Item>
                </Col>
              </Row>
            </Panel>
            <Panel header="Direct Debit">
              <Row gutter={16}>
                <Col sm={24} md={12}>
                  <Form.Item label="Pay by direct debit">
                    { getConnectedFieldDecorator('paymentMethod.stripeInvoice.invoiceRequested', {
                    })(
                      <Switch onChange={this.onStripeInvoice} checked={stripeInvoice} disabled={xeroInvoice}/>,
                    )}
                    {stripeInvoice && invoiceInstruction}
                  </Form.Item>
                </Col>
              </Row>
            </Panel>
            <Panel header="Invoice">
              <Row gutter={16}>
                <Col sm={24} md={12}>
                  <Form.Item label="Pay by invoice">
                    { getConnectedFieldDecorator('paymentMethod.xeroInvoice.invoiceRequested', {
                      normalize: (value, prevValue, allValues) => {
                        if (disableXeroInvoice) {
                          return false; // Set default value to false if the field is disabled
                        }
                        return value;
                      },
                    })(
                      switchToXeroDisable ? (
                        <Tooltip title={switchToXeroDisableInstruction}>
                          <Switch disabled />
                        </Tooltip>
                      )
                        : (<Switch onChange={this.onXeroInvoice} checked={!disableXeroInvoice && xeroInvoice} disabled={stripeInvoice || disableXeroInvoice} />),

                    )}
                    {disableXeroInvoice ? disableXeroInvoiceInstruction : xeroInvoice && invoiceInstruction}
                  </Form.Item>
                </Col>
              </Row>
            </Panel>
          </Collapse>
          <Row style={{ marginTop: '16px' }}>
            <Col sm={24} md={12}>{coupon}</Col>
          </Row>
          { editMode && <ButtonBar>
            {cancelable && (
              <Button
                disabled={saveInProgress}
                onClick={this.props.onCancel}
              >
                Cancel
              </Button>
            )}
            <Button
              loading={saveInProgress}
              htmlType='submit'
              type='primary'
            >
              {this.props.submitText || 'Save'}
            </Button>
          </ButtonBar> }
        </Spin>
      </Wrapper>
    );
  }
}

export const CardForm = props => (
  <ElementsConsumer>
    {({ stripe, elements }) => (
      <Inner {...props} stripe={stripe} elements={elements} />
    )}
  </ElementsConsumer>
);
